import { render, staticRenderFns } from "./RiskStatistics.vue?vue&type=template&id=a0adb400&scoped=true"
import script from "./RiskStatistics.vue?vue&type=script&lang=js"
export * from "./RiskStatistics.vue?vue&type=script&lang=js"
import style0 from "./RiskStatistics.vue?vue&type=style&index=0&id=a0adb400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0adb400",
  null
  
)

export default component.exports